import React, { FC, memo, useState, useEffect } from 'react';
import cls from './TariffSetAiLimit.module.scss';
import { FormControl } from 'react-bootstrap';
import { TariffAiLimitType } from '../tariff.types';
import AiProviderLabel from '../../../UIComponents/AiProviderLabel';

type TariffSetAiLimitProps = {
  aiLimits: TariffAiLimitType[];
  setAiLimits: React.Dispatch<React.SetStateAction<TariffAiLimitType[]>>;
  generalAiLimit?: number;
  onGeneralLimitChange?: (value: number) => void;
  isEditingGeneralLimit?: boolean;
};

const TariffSetAiLimit: FC<TariffSetAiLimitProps> = memo((props) => {
  const {
    aiLimits,
    setAiLimits,
    generalAiLimit,
    onGeneralLimitChange,
    isEditingGeneralLimit = false,
  } = props;

  const [countForAll, setCountForAll] = useState(generalAiLimit ?? -1);

  // Sync state with API prop
  useEffect(() => {
    if (generalAiLimit !== undefined) {
      setCountForAll(generalAiLimit);
    }
  }, [generalAiLimit]);

  const handleGeneralLimitChange = (value: number) => {
    setCountForAll(value);
    if (onGeneralLimitChange) {
      onGeneralLimitChange(value);
    }
  };

  return (
    <div className={cls.Container}>
      <div className={cls.Header}>
        <h2 className="title-4">AI</h2>
        <p className={cls.Subtitle}>Enter -1 for unlimited</p>
      </div>

      {/* General limit */}
      <div className={cls.Connection}>
        <label htmlFor="aiCountForAll" className="regular-text">
          General Limit
        </label>
        <FormControl
          type="number"
          id="aiCountForAll"
          value={countForAll}
          className={cls.ConnectionInput}
          readOnly={!isEditingGeneralLimit}
          onChange={(e) => {
            const value = Number(e.target.value);
            if (!isNaN(value)) {
              handleGeneralLimitChange(value);
            }
          }}
        />
      </div>

      {/* AI provider list */}
      <div className={cls.Connections}>
        {aiLimits.map((aiLimit) => (
          <div key={aiLimit.aiProvider} className={cls.Connection}>
            <label className={cls.AboutIntegration}>
              <AiProviderLabel aiProvider={aiLimit.aiProvider} />
            </label>
            <FormControl
              type="number"
              value={aiLimit.limit}
              className={cls.ConnectionInput}
              onChange={(e) => {
                const value = Number(e.target.value);
                if (!isNaN(value)) {
                  setAiLimits(
                    aiLimits.map((item) =>
                      item.aiProvider === aiLimit.aiProvider ? { ...item, limit: value } : item,
                    ),
                  );
                }
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
});

export default TariffSetAiLimit;
